<template lang="html">
  <footer class="footer">
    <div class="content has-text-centered">
      <p class="title is-3">DPAE</p>
      <p>
        Une solution développé par <a href="mailto:yoann.nouveau@partnersinterim.nc">Yoann NOUVEAU</a>
      </p>
      <p>
        Le code source est sous une license <a href="http://opensource.org/licenses/mit-license.php">MIT</a>
        Le contenu du site est sous une license <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.footer {
  background: #222;
  color: white;
}

.title {
  color: white;
}
</style>
